import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/landing/Header";
import {
  Hero,
  Operadoras,
  Solucoes,
  Marcia,
  Diferenciais,
  CtaFinal,
} from "@/components/landing/Sections";
import { Cotacao } from "@/components/landing/Cotacao";
import { Footer, FloatingWhats } from "@/components/landing/Footer";

const title = "Prime Saúde Benefícios — Planos de saúde com atendimento personalizado";
const description =
  "Cotação de planos de saúde individual, familiar, empresarial e melhor idade com diversas operadoras. Fale com a Márcia pelo WhatsApp.";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "pt_BR" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Operadoras />
        <Solucoes />
        <Marcia />
        <Diferenciais />
        <Cotacao />
        <CtaFinal />
      </main>
      <Footer />
      <FloatingWhats />
    </>
  );
}
